import { apiClient } from './client'
import type { SchedulerStats, ActivityResponse } from '@/types/models'
import { adaptSchedulerStatsResponse, adaptActivityListResponse } from '@/lib/utils/api-adapter'

export const schedulerApi = {
  /**
   * Get scheduler statistics
   * @param details - Include detailed scheduled items and dead jobs
   */
  async getStats(details = false): Promise<SchedulerStats> {
    const response = await apiClient.get<any>('/api/v1/scheduler/stats', {
      params: { details: details ? 'true' : undefined },
    })
    return adaptSchedulerStatsResponse(response)
  },

  /**
   * Get execution history
   */
  async getHistory(params?: {
    type?: 'feed' | 'workflow'
    status?: 'success' | 'error'
    limit?: number
    offset?: number
  }): Promise<ActivityResponse> {
    const response = await apiClient.get<any>('/api/v1/scheduler/history', { params })
    return adaptActivityListResponse(response)
  },

  /**
   * Retry a dead job
   */
  async retryJob(jobId: string): Promise<void> {
    await apiClient.post('/api/v1/scheduler/retry', { job_id: jobId })
  },

  /**
   * Clear all dead letter jobs
   */
  async clearDeadLetter(): Promise<void> {
    await apiClient.delete('/api/v1/scheduler/dead-letter')
  },
}
